import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import React from 'react';
import _get from 'lodash/get';
export function getComponentDisplayName(component) {
  var displayName = _get(component, 'type.displayName', '');

  var typeName = _get(component, 'type.name', '');

  var bareType = _get(component, 'type', '');

  return displayName || typeName || bareType;
}
export function toArray(element) {
  if (element === null || element === undefined) return [];
  return element.findIndex ? _toConsumableArray(element) : [element];
}
export function getChildren(component) {
  var children = _get(component, 'props.children', []);

  return React.Children.toArray(children);
}
export function doesComponentTypeMatch(component, type) {
  return getComponentDisplayName(component) === type;
}
export function findComponentsByType(component, type) {
  var componentsToExplore = toArray(component);
  var foundComponents = [];

  while (componentsToExplore.length > 0) {
    var currentComponent = componentsToExplore.pop();

    if (doesComponentTypeMatch(currentComponent, type)) {
      foundComponents.push(currentComponent);
    }

    var children = getChildren(currentComponent);
    componentsToExplore.push.apply(componentsToExplore, _toConsumableArray(children));
  }

  return foundComponents;
}